/**
 * Utility functions for handling scroll behavior
 */

/**
 * Resets the scroll position to the top of the page
 * @param behavior - The scroll behavior ('auto', 'smooth', or 'instant')
 */
export const scrollToTop = (behavior: ScrollBehavior = 'instant') => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior
  });
};

/**
 * Disables scroll on the body element
 * Useful for modals and overlays
 */
export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

/**
 * Enables scroll on the body element
 */
export const enableBodyScroll = () => {
  document.body.style.overflow = 'auto';
};

/**
 * Configures the browser's scroll restoration behavior
 * Call this once at app initialization
 */
export const configureScrollRestoration = () => {
  if ('scrollRestoration' in history) {
    // This prevents the browser from automatically restoring scroll position
    // We'll handle it manually with our hooks
    history.scrollRestoration = 'manual';
  }
};